<template>
  <el-dialog
    :visible.sync="showDialog"
    :before-close="handleClose"
    width="50%"
    top="9vh"
    custom-class="custom-scrollable"
  >
    <div class="text-xl text-root-2 font-bold mb-3">
      {{
        hasLimitedSettings ? 'TORUS MARA TERMS OF SERVICE' : 'Deposit Agreement'
      }}
    </div>
    <div class="overflow-y-scroll h-96 font-normal">
      <div v-if="hasLimitedSettings">
        <torus-mara-contract />
      </div>
      <div>
        <agreement-contract />
      </div>
    </div>
    <div class="md:flex justify-center gap-8 items-center mt-8">
      <div
        class="w-48 font-semibold hover:opacity-80 border-primary rounded-full border flex justify-center py-3 cursor-pointer text-primary"
        @click="handleClose"
      >
        Done
      </div>
      <div
        @click="proceedToDownload"
        class="border bg-primary cursor-pointer font-semibold hover:opacity-80 flex text-white items-center justify-start py-3 w-48 rounded-full"
      >
        <span class="ml-3"> <download-icon-white /></span>
        <div class="md:ml-10">Download</div>
      </div>
    </div>
    <vuehtml2pdf
      :manual-pagination="true"
      :filename="fileName"
      :pdf-quality="2"
      pdf-format="a4"
      pdf-content-width="800px"
      :enable-download="true"
      ref="DownloadComp"
      :show-layout="false"
    >
      <section slot="pdf-content">
        <div>
          <div v-if="hasLimitedSettings">
            <torus-mara-contract />
          </div>
          <div v-else>
            <agreement-contract />
          </div>
        </div>
      </section>
    </vuehtml2pdf>
  </el-dialog>
</template>

<script>
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  methods: {
    proceedToDownload () {
      this.generatePdf()
      this.$emit('closeDialog')
    },
    generatePdf () {
      this.$refs.DownloadComp.generatePdf()
    },
    handleClose () {
      this.$emit('closeDialog')
    }
  },
  components: {
    DownloadIconWhite: () => import('@/assets/icons/DownloadIconWhite.vue'),
    TorusMaraContract: () =>
      import('@/components/settings/TorusMaraContract.vue'),
    AgreementContract: () =>
      import('@/components/settings/AgreementContract.vue')
  },
  computed: {
    hasLimitedSettings () {
      return process.env.VUE_APP_SETTINGS_LIMITED === 'true'
    },
    fileName () {
      return this.hasLimitedSettings
        ? 'TORUS MARA TERMS OF SERVICE'
        : 'OVAL DEPOSIT AGREEMENT'
    }
  }
}
</script>

<style scoped>
>>> .el-dialog {
  border-radius: 30px;
  padding: 10px;
  height: 600px;
}
>>> .el-dialog__wrapper {
  overflow: hidden;
  top: 14px;
}
>>> .el-icon-close:before {
  opacity: 0.9;
  color: #c1c4ca;
}
>>> .el-dialog__headerbtn :hover {
  color: #c1c4ca !important ;
}
</style>
